import { WORDPRESS_API } from "shared/constants/api";


export const candidateRecruitment = {
  schoolYear: "2026/2027",
  startDate: "11.05.2026",
  endDate: "29.05.2026",
  recruitmentUrl: "https://pila.edu.com.pl/kandydat"
};


export const candidateApplicationDocuments = [
  {
    id: "podanie-technikum",
    title: "Podanie - Technikum",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Podanie-2026-2027-po-szkole-podstawowej.pdf`
  },
  {
    id: "podanie-szkola-branzowa",
    title: "Podanie - Szkoła Branżowa",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Podanie-2026-2027-po-szkole-podstawowej.pdf`
  },
  {
    id: "podanie-szkoly-zaoczne",
    title: "Podanie - Szkoły Zaoczne",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Podanie-szkoly-zaoczne.pdf`
  },
  {
    id: "praktyczna-nauka-zawodu",
    title: "Zaświadczenie - Praktyczna Nauka Zawodu",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/ZASWIADCZENIE-PRAKTYCZNA-NAUKA-ZAWODU-20262027.pdf`
  }
];


export const candidateSupportDocuments = [
  {
    id: "zgloszenie-poradnia",
    title: "Zgłoszenie do poradni psychologiczno-pedagogicznej",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/zgloszenie-do-poradni-2.pdf`
  },
  {
    id: "wniosek-zppp",
    title: "Wniosek o udzielenie pomocy ZPPP",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Wniosek-o-udzielenie-pomocy-ZPPP-1.pdf`
  }
];


export const candidateRecruitmentDocuments = [
  {
    id: "rekrutacja-szkola-ponadpodstawowa",
    title: "Zasady rekrutacji - Szkoła Ponadpodstawowa",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Rekrutacja-2026.2027-szkoly-dla-mlodziezy.pdf`
  },
  {
    id: "rekrutacja-bs2-policealna",
    title: "Zasady rekrutacji - Branżowa Szkoła II Stopnia i Szkoła Policealna",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Rekrutacja-2026.2027-BSIIST-i-Szkola-Policealna.pdf`
  },
  {
    id: "rekrutacja-lo-dorosli",
    title: "Zasady rekrutacji - LO dla Dorosłych",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Rekrutacja-2026.2027-LO-dla-Doroslych.pdf`
  },
  {
    id: "komisja-rekrutacyjna",
    title: "Komisja rekrutacyjna",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Powolanie-komisji-rekrutacyjno-kwalifikacyjnej-2026.2027.pdf`
  }
];